import { Alert, AlertTitle, Box, Typography } from '@mui/material';
import { VisitorGroup } from 'graphql/generated/graphqlTypes';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import useDrawerContext from 'v2/components/Drawer/useDrawerContext';
import EditableCard from 'v2/components/EditableCard/EditableCard';
import { getScheduleLines } from 'v2/utils/scheduleDisplay';
import EditScheduleDrawer from '../drawers/EditScheduleDrawer';

interface Props {
  visitorGroup: VisitorGroup;
}

const Schedule: React.FC<Props> = ({ visitorGroup }) => {
  const { translation } = useTranslation();
  const { openDrawer } = useDrawerContext();

  const scheduleLines = getScheduleLines(visitorGroup, translation);

  const handleEditSchedule = () => {
    openDrawer(<EditScheduleDrawer visitorGroup={visitorGroup} />);
  };

  return (
    <EditableCard title={translation.schedule} editButtonId="editSchedule" onEditClick={handleEditSchedule} spacing={1}>
      {scheduleLines.length === 0 ? (
        <Alert severity="error" variant="standard">
          <AlertTitle>{translation.no_schedule_assigned}</AlertTitle>
          <Typography variant="body2">{translation.add_schedule_hint}</Typography>
        </Alert>
      ) : (
        <Box sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', columnGap: 2 }}>
          {scheduleLines.map(({ day, time }, i) => (
            <React.Fragment key={i}>
              <Typography id="schedule-day" variant="body2" sx={{ textTransform: 'uppercase' }}>
                {day}
              </Typography>
              <Typography id="schedule-time" variant="body2">
                {time}
              </Typography>
            </React.Fragment>
          ))}
        </Box>
      )}
    </EditableCard>
  );
};

export default Schedule;
